/** @file ringTurn: the Babylon local rotation that turns a gizmo ring about its own axis by an angle. */
import type { Quaternion } from '@babylonjs/core/Maths/math.vector.js';

/**
 * A right-handed turn by `rad` about unit-frame axis `k`, written into `out` as Babylon's quaternion of the swapped
 * y/z frame (`toBabylonQuat`: `(x, y, z, w) -> (-x, -z, -y, w)`). Allocates nothing.
 */
export function ringTurn(k: 0 | 1 | 2, rad: number, out: Quaternion): Quaternion {
  const s = Math.sin(rad / 2);
  return out.set(k === 0 ? -s : 0, k === 2 ? -s : 0, k === 1 ? -s : 0, Math.cos(rad / 2));
}
